SP.UI = Garnish.Base.extend({
    $siteWrapper: null,

    $mobileMenuBtn: null,
    $mobileSearchBtn: null,
    $mainNavWrapper: null,
    $mainNav: null,
    $secondaryNav: null,
    $searchWrapper: null,

    // Scroll Direction
    $backToTopBtn: null,
    lastScrollTop: 0,

    // Loaders
    $loaderElement: null,

    // scroll to top fade out
    timer: null,

    init() {
        this.$siteWrapper = $('#site-wrapper')
        this.$mainNavWrapper = $('.main-nav-wrapper')
        this.$mainNav = $('.main-nav')
        this.$secondaryNav = $('.secondary-nav')
        this.$searchWrapper = $('.search-wrapper')
        this.$mobileMenuBtn = $('#mobile-menu-trigger')
        this.$mobileSearchBtn = $('.mobile-menu-search')

        this.$loaderElement = $('.full-screen-loader')

        // Scroll Direction
        this.$backToTopBtn = $('.back-to-top')
        this.addListener(Garnish.$win, 'scroll', this.checkScrollDirection)
        this.addListener(this.$backToTopBtn, 'click', this.backToTop)
        this.addListener(this.$mobileSearchBtn, 'click', this.showSearchForm)

        // fade out scroll after not scrolling for a 1.5 secs
        this.addListener(Garnish.$win, 'scroll', this.fadeOutBackToTop)

        // Response media queries
        this.registerMediaQueries()

        // Various GA Events
        this.GAEvents()

    },

    checkScrollDirection() {
        if ($(window).scrollTop() > $('body').height() / 2) {
            this.$backToTopBtn.addClass('show')
        } else {
            this.$backToTopBtn.removeClass('show')
        }

        this.lastScrollTop = (document.body.getBoundingClientRect()).top;
    },

    fadeOutBackToTop() {
        if (this.timer !== null) {
            clearTimeout(this.timer)
        }
        this.timer = setTimeout(() => {
            this.$backToTopBtn.removeClass('show')
        }, 1500)
    },

    //     if ((document.body.getBoundingClientRect()).top > this.lastScrollTop) {
    //         this.$backToTopBtn.addClass('show')
    //     } else {
    //         this.$backToTopBtn.removeClass('show')
    //     }
    //
    //     this.lastScrollTop = (document.body.getBoundingClientRect()).top;
    // },

    createLoader() {
        this.$loaderElement.addClass('active')
    },

    removeLoader() {
        this.$loaderElement.removeClass('active')
    },

    registerMediaQueries() {
        let self = this

        enquire.register("screen and (max-width: 1099px)", {
            setup: function () {
            },
            match: function () {
                window.mobileMenu.disableDesktop()
            },
            unmatch: function () {
                window.mobileMenu.enableDesktop()
            }
        })
    },

    showSearchForm() {
        this.updateMobileNavigation('search')
    },

    updateMobileNavigation(type) {
        let searchBar = this._checkIfSearchActive()
        let mainNav = this._checkIfMainNavActive()

        if (type === 'nav') {

            if (searchBar) {
                this.hideSearch()
            }

            if ($('body').hasClass('activate-mobile-menu')) {
                this.hideMainMenu()
            } else {
                this.showMainMenu()
            }
        }

        if (type === 'search') {
            if (mainNav) {
                this.hideMainMenu()
            }

            if ($('body').hasClass('activate-mobile-search')) {
                this.hideSearch()
            } else {
                this.showSearch()
            }
        }
    },

    hideSearch() {
        this.$mobileSearchBtn.removeClass('active')
        this.$mobileSearchBtn.attr('aria-expanded', 'false')
        this.$searchWrapper.removeClass('active')
        this.$mainNavWrapper.removeClass('active')
        $('body').removeClass('activate-mobile-search')
    },

    showSearch() {
        this.$mobileSearchBtn.addClass('active')
        this.$mobileSearchBtn.attr('aria-expanded', 'true')
        this.$searchWrapper.addClass('active')
        this.$mainNavWrapper.addClass('active')
        $('body').addClass('activate-mobile-search')
    },

    hideMainMenu() {
        this.$mobileMenuBtn.removeClass('open')
        this.$mobileMenuBtn.attr('aria-expanded', 'false')
        this.$mainNavWrapper.removeClass('active')
        this.$mainNavWrapper.find('.submenu').siblings().removeClass('active')
        this.$mainNavWrapper.find('.submenu').parent().removeClass('active')
        $('body').removeClass('activate-mobile-menu')
    },

    showMainMenu() {
        this.$mobileMenuBtn.addClass('open')
        this.$mobileMenuBtn.attr('aria-expanded', 'true')
        this.$mainNavWrapper.addClass('active').find('li.active').removeClass('active')
        $('body').addClass('activate-mobile-menu')
    },

    _checkIfSearchActive() {
        return !!$('body').hasClass('activate-mobile-search')
    },

    _checkIfMainNavActive() {
        return !!$('body').hasClass('activate-mobile-menu')
    },

    backToTop(e) {
        e.preventDefault()
        $('body').velocity('scroll', {
            offset: 0,
            mobileHA: false
        })
    },

    GAEvents() {
        // Klaviyo Forms
        // https://help.klaviyo.com/hc/en-us/articles/360003953111-Adding-Custom-JavaScript-Events-to-Forms
        this.addListener(window, 'klaviyoForms', this.handleKlaviyoForms)
    },

    handleKlaviyoForms(e) {
        if (e.detail.type === 'open') {
            ga('send', 'event', 'Klaviyo form', 'form_open', e.detail.formId);
        }
        if (e.detail.type === 'submit') {
            ga('send', 'event', 'Klaviyo form', 'form_submit', e.detail.formId)
            ga('send', 'event', 'Footer', 'Email', 'Sign-up Submit')
        }
    }
})
